import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import { formatEpochDate } from 'Lib/stringHelpers';

interface DateCellRendererProps {
    value: string;
    align?: 'center' | 'flex-start' | 'flex-end';
}

const muiStyles = makeStyles({
    root: {
        whiteSpace: 'normal' as const,
        alignSelf: (props: DateCellRendererProps) => props.align || null
    },
    date: { lineHeight: '18px' }
});

const DateCellRender = (props: DateCellRendererProps) => {
    const { value } = props;

    const {
        root,
        date
    } = muiStyles(props);

    return (
        <Grid
            className={root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {value && value === '0' ?
                <span>-</span>
                : (
                    <>
                        <span className={date}>{formatEpochDate(value, 'MMM DD YYYY')}</span>
                        <span className={date}>{formatEpochDate(value, 'HH:mm:ss')}</span>
                    </>
                )}
        </Grid>
    );
};

export default DateCellRender;